<div class="container">
    <h1>Tratamos apenas os dados pessoais mínimos necessários e adequados para cada finalidade:</h1>
    <div class="card-list">
        <app-card-icon
            *ngFor="let card of firstCardList"
            [cardIconUrl]="card.cardIconUrl"
            [cardTitle]="card.cardTitle"
            [cardDescription]="card.cardDescription"
            [cardDescriptionFull]="card.cardDescriptionFull"
            [cardLink]="card.cardLink">
        </app-card-icon>
    </div>
</div>
<div class="gray-content">
    <div class="container">
        <h2>Somos um parceiro de confiança para muitas empresas e organizações públicas e privadas.</h2>
        <p>Compartilhamos seus dados pessoais apenas para as pessoas e empresas que consultam nossos serviços para as finalidades descritas acima. Os principais segmentos de empresas que consultam nossos serviços são:</p>
        <div class="minimal-card-list">
            <app-card-icon
            *ngFor="let card of secondCardList"
            [minimal]="true"
            [cardIconUrl]="card.cardIconUrl"
            [cardTitle]="card.cardTitle">
        </app-card-icon>
        </div>
        <div class="footer-note">
            <p>Além disso, também podemos disponibilizar os dados pessoais, quando estritamente necessário, a:</p>
            <ul>
                <li>Empresas do grupo Experian que gerenciam algumas partes dos nossos serviços;</li>
                <li>Parceiros de negócios;</li>
                <li>Fornecedores;</li>
                <li>Revendedores, distribuidores e agentes envolvidos na promoção e prestação dos nossos serviços.</li>
            </ul>
        </div>
    </div>
</div>
<app-footer-lgpd></app-footer-lgpd>
<app-modal-sidebar></app-modal-sidebar>